export class PocsagDetailItem {
    constructor (public id: number,
                 public uid: string,
                 public ort: string,
                 public diveradata: string,
                 public alarmstichwort: string[] ,
                 public alarmierte_einheiten: string[],
                 public koordinateX: string,
                 public koordinateY: string,
                 public hinweis: string) {
    }
}
